import moment from 'moment';
import React, { useContext, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { markOrdertAsConsultantDecision } from '../../../../API/repositories/order';
import Loading from '../../../../common/components/Loading';
import PopUp from '../../../../common/components/PopUp';
import { useRequestsContext } from '../../../../common/hooks/requestHook';
import ConfirmationView from '../order/ConfirmationView';
import { checkIfCommentAdded } from '@/common/functions/checkIfCommentAdded';
import Confirm from './Confirm';
import ConfirmPayment from '../ConfirmPayment';
import { MIN_SHIFT_OFFSET } from '@/common/constants/minShiftOffset';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';
import { MAX_SHIFT_DAYS } from '@/pages/consultant/calling/buttons/Buttons';
import { AuthContext } from '@/common/contexts/authContext';


const Flex = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const ButtonWrapper = styled.div`
	height: 40px;
	display: flex;
	justify-content: space-between;
`;

const Wrapper = styled.div`
	height: fit-content;
	display: grid;
`;

const StatusButton = styled.span`
	width: fit-content;
	font-size: 12px;
	padding: 5px;
	border-radius: 10px;
	height: fit-content;
`;

const SHIFT_STATUSES = [
	{ label: 'No Product Info', staus: 'NO_PRODUCT_INFO' },
	{ label: 'Wrong time', staus: 'BAD_TIME' },
	{ label: 'other', staus: 'OTHER' },
];

const NO_RESPONSE_STATUSES = [
	{ label: 'rejected_call', staus: 'REJECTED_CALL' },
	{ label: 'voicmail', staus: 'VOICMAIL' },
	{ label: 'no answer', staus: 'NO_ANSWER' },
	{ label: 'VOIP error', staus: 'VOIP_ERROR' },
	{ label: 'other', staus: 'OTHER' },
];

const Buttons = ({
	product,
	contact,
	chosenProductData,
	comments = [],
	data,
}) => {
	const { authUser } = useContext(AuthContext);

	const { id } = useParams();
	const navigate = useNavigate();
	const { translation } = useTranslationContext();

	const minDate = moment().format('YYYY-MM-DDTHH:mm');
	const maxDate = moment()
		.add(MAX_SHIFT_DAYS, 'days')
		.format('YYYY-MM-DDTHH:mm');
	const defaultShiftDate = moment().add(1, 'days').format('YYYY-MM-DDTHH:mm');

	const [shiftReason, setshiftReason] = useState('BAD_TIME');
	const [noResponseReason, setNoResponseReason] = useState('REJECTED_CALL');
	const [isConfirm, setIsConfirm] = useState(false);

	const [confirmDecision, setConfirmDecision] = useState(false);
	const [text, setText] = useState();
	const [decision, setDecision] = useState();

	const [isConfirmNotAllowed, setIsConfirmNotAllowed] = useState(false);
	const [isShift, setIsShift] = useState(false);
	const [isNoResponse, setIsNoResponse] = useState(false);
	const { hasUnfilledRequest, makeRequest } = useRequestsContext();
	const [confirmPayment, setConfirmPyment] = useState();
	const [shiftDate, setShiftDate] = useState(defaultShiftDate);

	const currentUserId = authUser.id;

	const wasCommentAdded = useMemo(
		() => checkIfCommentAdded(currentUserId, comments),
		[currentUserId, comments],
	);
	const { addMessage } = useMessageQueueContext();

	const handleConfirmOrder = (e) => {
		e.preventDefault();

		if (
			chosenProductData.length === 0 ||
			contact.postal_code === undefined ||
			contact.city === undefined ||
			contact.street === undefined
		) {
			setIsConfirmNotAllowed((prev) => !prev);
		} else {
			const price = chosenProductData.reduce(
				(prev, next) => prev + next.price,
				0,
			);

			if (
				contact.country === 'cz' &&
				!contact.hasPromotion &&
				price < 1900 * 5
			) {
				setIsConfirmNotAllowed(false);
			} else {
				setIsConfirm((prev) => !prev);
			}
		}
	};

	const handleClick = async (e, type) => {
		e.preventDefault();

		if (['SHIFT', 'NO_RESPONSE'].includes(type)) {
			setIsShift(() => false);
			setIsNoResponse(() => false);
		}

		setConfirmDecision(true);
		setText(type);
		setDecision(type);
	};

	const goDashboard = () => {
		navigate('/consultant/dashboard');
	};

	const handleDecision = async (type, additionalInformation) => {
		const responseDecision = await makeRequest(
			markOrdertAsConsultantDecision.bind(this, authUser.id, id, {
				type: type,
				additionalInformation: additionalInformation,
			}),
		);

		if (responseDecision.data && !(type === 'CONFIRM')) {
			goDashboard();
		}
	};

	const onDeceline = () => {
		setConfirmDecision(false);
	};

	const onConfirm = async () => {
		switch (decision) {
			case 'SHIFT':
				if (MIN_SHIFT_OFFSET > new Date(shiftDate) - new Date()) {
					addMessage(
						'Shift date must be at least 10 minutes from now',
						'error',
					);
					return;
				}
				handleDecision('SHIFT', {
					shiftReason,
					shiftDate: new Date(shiftDate).toISOString(),
				});
				break;
			case 'RESIGN':
				handleDecision('RESIGN', {});
				break;
			case 'TRASH':
				handleDecision('TRASH', {});
				break;
			case 'INFORMED':
				handleDecision('INFORMED', {});
				break;
			case 'NO_RESPONSE':
				handleDecision('NO_RESPONSE', { noResponseReason: noResponseReason });
				break;
			default:
		}
	};

	return (
		<Wrapper>
			{hasUnfilledRequest(markOrdertAsConsultantDecision) && <Loading />}
			<ButtonWrapper>
				<Flex>
					<ActionButton
						disabled={!wasCommentAdded}
						style={{ fontSize: '14px', padding: '8px' }}
						onClick={(e) => setIsShift((prev) => !prev)}
						text={translation.shift}
					/>
					<ActionButton
						disabled={!wasCommentAdded}
						defaultText={translation.informed}
						style={{ fontSize: '14px', padding: '8px' }}
						onClick={(e) => handleClick(e, 'INFORMED')}
					/>
					<ActionButton
						disabled={!wasCommentAdded}
						style={{ fontSize: '14px', padding: '8px' }}
						onClick={(e) => setIsNoResponse((prev) => !prev)}
						text={translation.noResponse}
					/>
					<ActionButton
						disabled={!wasCommentAdded}
						style={{ fontSize: '14px', padding: '8px' }}
						onClick={(e) => handleClick(e, 'RESIGN')}
						text={translation.resign}
					/>
					<ActionButton
						disabled={!wasCommentAdded}
						style={{ fontSize: '14px', padding: '8px' }}
						onClick={(e) => handleClick(e, 'TRASH')}
						text={translation.trash}
						color={Colors.red}
					/>
				</Flex>
				<ActionButton
					disabled={!wasCommentAdded}
					style={{ fontSize: '14px', padding: '8px' }}
					onClick={(e) => handleConfirmOrder(e)}
					color={Colors.green}
					defaultText={translation.confirm}
				/>
				{confirmDecision ? (
					<Confirm
						shiftDate={shiftDate}
						text={text}
						onDeceline={onDeceline}
						onConfirm={onConfirm}
					/>
				) : (
					''
				)}
			</ButtonWrapper>
			{confirmPayment && (
				<ConfirmPayment
					data={data}
					setClose={setConfirmPyment}
					inbound={false}
				/>
			)}
			{isConfirm && (
				<PopUp setShow={setIsConfirm}>
					<ConfirmationView
						setIsConfirm={setIsConfirm}
						product={product}
						shippingData={contact}
						chosenProductData={chosenProductData}
					/>
				</PopUp>
			)}
			{isConfirmNotAllowed && (
				<PopUp setShow={setIsConfirmNotAllowed}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							flexDirection: 'column',
							gap: '30px',
						}}
					>
						<h4>Please fill all required fields</h4>
						<ActionButton
							color={Colors.green}
							onClick={() => setIsConfirmNotAllowed((prev) => !prev)}
							text='OK'
						/>
					</div>
				</PopUp>
			)}
			{isShift && (
				<PopUp setShow={setIsShift}>
					<h3>Decision: SHIFT</h3>
					<Flex
						style={{ margin: '20px 20px 0px 20px', flexDirection: 'column' }}
					>
						<Flex style={{ margin: '20px 20px 20px 20px', gap: '40px' }}>
							{SHIFT_STATUSES.map((status) => (
								<StatusButton
									style={{ cursor: 'pointer' }}
									className={
										shiftReason === status.staus
											? 'check animation-scale'
											: 'notCheck animation-scale'
									}
									key={status.staus}
									onClick={() => setshiftReason(() => status.staus)}
								>
									{status.label}
								</StatusButton>
							))}
						</Flex>
						<div style={{ display: 'flex', gap: '20px' }}>
							<input
								type='datetime-local'
								min={minDate}
								max={maxDate}
								value={shiftDate}
								onChange={(e) => setShiftDate(e.target.value)}
							/>
							<ActionButton
								text='Make Shift'
								onClick={(e) => {
									handleClick(e, 'SHIFT');
								}}
							/>
						</div>
					</Flex>
				</PopUp>
			)}
			{isNoResponse && (
				<PopUp setShow={setIsNoResponse}>
					<h3>Decision: NO RESPONSE</h3>
					<Flex
						style={{ margin: '20px 20px 0px 20px', flexDirection: 'column' }}
					>
						<Flex style={{ margin: '20px 20px 20px 20px', gap: '40px' }}>
							{NO_RESPONSE_STATUSES.map((status) => (
								<StatusButton
									className={
										noResponseReason === status.staus
											? 'check animation-scale'
											: 'notCheck animation-scale'
									}
									key={status.staus}
									onClick={() => setNoResponseReason(() => status.staus)}
									style={{ cursor: 'pointer' }}
								>
									{status.label}
								</StatusButton>
							))}
						</Flex>
						<ActionButton
							onClick={(e) => handleClick(e, 'NO_RESPONSE')}
							text='Save'
						/>
					</Flex>
				</PopUp>
			)}
		</Wrapper>
	);
};

export default Buttons;
